export const UNLOCK_INVENTORY_FORM_PREFIX = 'unlockInventoryForm';

export const UNLOCK_INVENTORY_FIELDS_NAMES = {
  FULL_NAME: `${UNLOCK_INVENTORY_FORM_PREFIX}.fullName`,
  EMAIL: `${UNLOCK_INVENTORY_FORM_PREFIX}.email`,
  PHONE_NUMBER: `${UNLOCK_INVENTORY_FORM_PREFIX}.phoneNumber`,
  DEALERSHIP_NAME: `${UNLOCK_INVENTORY_FORM_PREFIX}.dealershipName`,
  DEALERSHIP_STATE: `${UNLOCK_INVENTORY_FORM_PREFIX}.dealershipState`,
  INVENTORY_SYNDICATION_PROVIDER: `${UNLOCK_INVENTORY_FORM_PREFIX}.inventorySyndicationProvider`,
  CREDIR_APPLICATION_SYSTEM: `${UNLOCK_INVENTORY_FORM_PREFIX}.creditApplicationSystem`,
  CONFIRM_PRICE: `${UNLOCK_INVENTORY_FORM_PREFIX}.confirmPrice`,
  CONFIRM_TERMS: `${UNLOCK_INVENTORY_FORM_PREFIX}.confirmTerms`,
};
